import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deactivateAdmin } from '../api/adminsApi';
import { ADMIN_ACCOUNTS_QUERY_KEY } from './useAdminAccounts';

// PARA-114, AC-3/AC-E3/AC-E4: инвалидирует ['admin','admins'] после успешной
// деактивации; при 422 (self/last-active/already-inactive) тоже
// переинвалидирует — устраняет рассинхронизацию списка (AC-E4).
export function useDeactivateAdmin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (adminId: number) => deactivateAdmin(adminId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNTS_QUERY_KEY });
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNTS_QUERY_KEY });
    },
  });
}
